import { html } from '@webtides/element-js';

import '../spec-list-filter/spec-list-filter';
import '../spec-color-list-filter/spec-color-list-filter';

import { templateFactory } from '@zeg/base-light-module/frontend/components/structures/_category-page/filter-specs/filter-specs.template';

const filterButtonIcon = html` <svg-icon name="next"></svg-icon> `;
export default templateFactory({ filterButtonIcon });
